/* Explicit FROZT offers. Shopify lines stay authoritative; no automatic SKU conversions. */
(() => {
  'use strict';
  const titles = ['Complete FROZT System','Complete System + Refills','Daily Routine Pack','Ice Bar Pack','Facial Brush','Daily Cleanser','Ice Bar'];
  const axes = ['brush','cleanser','iceBar'];
  const staleProperty = key => /^_frozt_(partial_|recipe|source_flow|role$|add_on$)/.test(key);
  const stable = value => JSON.stringify(Object.entries(value || {}).sort(([a],[b]) => a.localeCompare(b)));
  const idOf = item => Number(item.variant_id || item.id);
  const identity = item => idOf(item) + ':' + stable(item.properties) + ':' + (item.selling_plan_allocation?.selling_plan?.id || '');
  const count = (cart, key) => (cart.items || []).filter(item => identity(item) === key).reduce((n,item) => n + item.quantity,0);
  const quantity = (cart,id) => (cart.items || []).filter(item => idOf(item) === id).reduce((n,item) => n + item.quantity,0);
  const publicProperties = item => Object.fromEntries(Object.entries(item.properties || {}).filter(([key]) => !staleProperty(key)));
  const clone = value => JSON.parse(JSON.stringify(value));
  function attach(root) {
    const c = root.froztUpgradeBridge;
    if (!c || root.froztPartialUpgrades) return;
    const recipes=c.recipes;
    root.classList.add('frozt-explicit-cart');
    const find = selector => root.querySelector(selector);
    const show = (node, visible) => { if (node) node.hidden = !visible; };
    const text = (node, value) => { if (node) node.textContent = value; };
    const primary = find('[data-frozt-cart-upgrade]');
    const secondary = find('[data-frozt-pack-alternative]');
    const stocked = find('[data-frozt-stocked-upgrade]');
    const ladder = find('[data-frozt-cart-progress]');
    const confirmation = find('[data-frozt-cart-complete-status]');
    const appliedCopy = find('[data-frozt-bundle-applied] strong')?.textContent;
    const top = find('[data-frozt-top-progress]');
    const funnel = find('.frozt-cart-drawer__bundle-funnel');
    const primaryBadge = primary?.querySelector('.frozt-pack-badge')?.textContent;
    const refillBadge = secondary?.querySelector('.frozt-pack-badge')?.textContent;
    const primaryChips = [...(primary?.querySelectorAll('.frozt-cart-drawer__upgrade-badges > span') || [])].map((node,index) => primary.dataset['offerChip' + (index+1)] || node.textContent);
    const refillChips = [...(secondary?.querySelectorAll('.frozt-pack-chips > span') || [])].map(node => node.textContent);
    let pending = null, reading = null, selection = 1, selectionSignature = '', currentPlans = new Map();
    let selector = null;
    const journalKey = 'frozt-explicit-cart-v1:' + location.host + ':' + root.id;
    const catalog = () => (c.offerData() || []).map((row,index) => ({
      id:Number(row[0]), price:Number(row[1]), available:row[2] === true,
      stock:row[3] == null ? Infinity : Math.max(0,Number(row[3])), image:row[4] || '', index
    }));
    const read = () => c.request(c.shopRoot + 'cart.js',{cache:'no-store'});
    const post = (endpoint, data) => c.request(c.shopRoot + endpoint,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(data)});
    const physical = cart => {
      const totals=c.totals(cart);
      return axes.map(key => totals[key]);
    };
    const money = (n,cart) => c.money(Math.round(n),cart.currency || c.offerCurrency || 'EUR');
    const unit = item => Number.isFinite(Number(item.final_line_price)) ? Number(item.final_line_price) / item.quantity : Number(item.final_price ?? item.price);
    const rows = (cart,id,group) => (cart.items || []).filter(item => idOf(item) === id && !item.selling_plan_allocation && (!group || stable(publicProperties(item)) === group));
    const take = (items,n) => {
      const result = [];
      for (const item of items) {
        const used = Math.min(n,item.quantity);
        if (used) result.push({item,take:used});
        n -= used;
        if (!n) break;
      }
      return n ? null : result;
    };
    const offerReady = (cart,target,n) => target && target.id > 0 && target.price > 0 && target.available && quantity(cart,target.id) + n <= target.stock;
    function makePlan(cart,key,targetIndex,sources,n,helper) {
      const target = catalog()[targetIndex];
      if (!sources?.length || !offerReady(cart,target,n)) return null;
      const properties = publicProperties(sources[0].item);
      if (sources.some(row => stable(publicProperties(row.item)) !== stable(properties))) return null;
      const sourceCost = sources.reduce((sum,row) => sum + unit(row.item) * row.take,0);
      return {key,target,n,sources,properties,helper,delta:Math.round(target.price * n - sourceCost)};
    }
    function plans(cart) {
      const offers = catalog(), q = offers.map(offer => quantity(cart,offer.id));
      const groups = new Set((cart.items || []).filter(item => !item.selling_plan_allocation && offers.some(offer => offer.id === idOf(item))).map(item => stable(publicProperties(item))));
      let result = [], capacity = 1, signature = '', selectedGroup = '';
      // Bundle ownership is an actual SKU, not an inferred physical recipe.
      if (q[2] && q[3]) {
        signature = 'mixed';
        const group = [...groups].find(group => rows(cart,offers[2].id,group).length && rows(cart,offers[3].id,group).length);
        if (group) {
          const sources = [...take(rows(cart,offers[2].id,group),1),...take(rows(cart,offers[3].id,group),1)];
          const helper = q[2] === 1 && q[3] === 1 ? 'Replaces both current packs · Free shipping' : 'Replaces 1 of each current pack · Free shipping';
          result = [makePlan(cart,'mixed',1,sources,1,helper)].filter(Boolean);
        }
      } else if (q[0]) {
        const group = [...groups].find(group => rows(cart,offers[0].id,group).length);
        const eligible = rows(cart,offers[0].id,group);
        capacity = eligible.reduce((n,item) => n + item.quantity,0);
        signature = 'complete:' + group + ':' + capacity;
        selectedGroup = group;
        result = [{key:'refills',target:1,sourceIndex:0,helper:'Replaces your selected Complete System · Free shipping'}];
      } else if (q[1]) {
        signature = 'refills';
      } else if (q[2] || q[3]) {
        const index = q[2] ? 2 : 3;
        const group = [...groups].find(group => rows(cart,offers[index].id,group).length);
        selectedGroup = group;
        capacity = rows(cart,offers[index].id,group).reduce((n,item) => n + item.quantity,0);
        signature = index + ':' + group + ':' + capacity;
        result = (q[4] ? [
          {key:'refills',target:1,sourceIndex:index,helper:'Replaces your current pack + 1 Brush · Free shipping'}
        ] : [
          {key:'complete',target:0,sourceIndex:index,helper:'Replaces your current pack · Free shipping'},
          {key:'refills',target:1,sourceIndex:index,helper:'Replaces your current pack · Free shipping'}
        ]);
      } else {
        signature = 'loose';
        const group = [...groups].find(group => [4,5,6].some(index => rows(cart,offers[index].id,group).length));
        for (const target of [0,1]) {
          const sources = [];
          for (const index of [4,5,6]) {
            const needed = recipes[target][index-4];
            const eligible = rows(cart,offers[index].id,group);
            const n = Math.min(needed,eligible.reduce((sum,item) => sum + item.quantity,0));
            if (n) sources.push(...take(eligible,n));
          }
          const exact = sources.reduce((n,row) => n + row.take,0) === recipes[target].reduce((n,v) => n + v,0);
          const helper = exact ? 'Replaces the matching loose products · Free shipping' : 'Replaces selected loose products · Free shipping';
          result.push(makePlan(cart,target ? 'refills' : 'complete',target,sources,1,helper));
        }
        // A matching loose middle pack stays loose until its offer is clicked.
        if (!q[4]) {
          const target = q[5] >= q[6] ? 2 : 3;
          const sources = [];
          let matches = true;
          for (const index of [5,6]) {
            const used = take(rows(cart,offers[index].id,group),recipes[target][index-4]);
            if (!used) matches = false; else sources.push(...used);
          }
          if (matches) result.push(makePlan(cart,'pack',target,sources,1,'Replaces the matching loose products'));
        }
        result = result.filter(Boolean);
      }
      if (result.some(plan => plan && !plan.sources)) {
        const availableUnits=Math.max(0,...result.filter(Boolean).map(plan => {
          const target=offers[plan.target];
          return target.available ? Math.max(0,target.stock-quantity(cart,target.id)) : 0;
        }));
        capacity=Math.min(capacity,availableUnits);
      }
      if (signature !== selectionSignature) { selection = 1; selectionSignature = signature; }
      selection = Math.max(1,Math.min(selection,capacity || 1));
      return {capacity,signature,items:result.map(plan => {
        if (plan?.sources) return plan;
        const sources = take(rows(cart,offers[plan.sourceIndex].id,selectedGroup),selection);
        const withBrush = q[4] && (plan.sourceIndex === 2 || plan.sourceIndex === 3);
        let brushes = 0;
        if (withBrush) {
          brushes = Math.min(selection,rows(cart,offers[4].id,selectedGroup).reduce((n,item) => n + item.quantity,0));
          if (!brushes || !sources) return null;
          sources.push(...take(rows(cart,offers[4].id,selectedGroup),brushes));
        }
        const helper = selection > 1 ? 'Replaces ' + selection + ' selected ' + (plan.sourceIndex === 0 ? 'Complete Systems' : 'packs') + (withBrush ? ' + ' + brushes + ' Brush' : '') + ' · Free shipping' : plan.helper;
        return makePlan(cart,plan.key,plan.target,sources,selection,helper);
      }).filter(Boolean)};
    }
    const contents = index => ['1 Brush + 1 Cleanser + 1 Ice Bar','1 Brush + 2 Cleansers + 2 Ice Bars','2 Cleansers + 1 Ice Bar','1 Cleanser + 2 Ice Bars','Complete your full 3-step system'][index];
    const looseCompleteDisplay = (cart,plan) => plan?.key === 'complete' && physical(cart).every(n => n > 0) && !catalog().slice(0,4).some(offer => quantity(cart,offer.id));
    function priceNodes(container,plan,cart) {
      if (!container) return;
      container.replaceChildren();
      const price = document.createElement('strong');
      price.style.setProperty('font-size','16px','important');
      if (plan.delta < 0) {
        const offers = catalog();
        const sameItems = recipes[plan.target.index].every((amount,axis) => plan.sources.reduce((sum,row) => {
          const index = offers.findIndex(offer => offer.id === idOf(row.item));
          return sum + (recipes[index]?.[axis] || 0) * row.take;
        },0) === amount * plan.n);
        price.textContent = money(plan.target.price * plan.n,cart);
        price.style.whiteSpace = 'normal';
        const badge = document.createElement('small');
        badge.textContent = 'Save ' + money(-plan.delta,cart) + (sameItems ? '' : ' on this switch');
        if (sameItems) {
          const old = document.createElement('s');
          old.textContent = money(plan.target.price * plan.n - plan.delta,cart);
          container.append(old,document.createTextNode(' → '),price,badge);
        } else container.append(price,badge);
        return;
      }
      price.textContent = plan.delta > 0 ? '+' + money(plan.delta,cart) : 'Switch at no extra cost';
      if (plan.delta === 0) price.style.whiteSpace = 'normal';
      container.append(price);
      if (plan.delta === 0 || plan.target.index === 4) return;
      const regular = recipes[plan.target.index].reduce((sum,n,axis) => sum + n * catalog()[axis+4].price,0) * plan.n;
      const discount = Math.max(0,regular - plan.target.price * plan.n);
      if (discount > 0) {
        const badge = document.createElement('small');
        badge.textContent = 'Save ' + money(discount,cart) + ' vs separate items';
        container.append(badge);
      }
    }
    function paintCard(card,plan,cart,kind) {
      if (!card || !plan) { show(card,false); return; }
      show(card,true);
      let button,title,subline,helper,prices;
      if (kind === 'primary') {
        button = card.querySelector('[data-frozt-upgrade-button]');
        title = card.querySelector('[data-frozt-upgrade-title]');
        subline = card.querySelector('[data-frozt-upgrade-subline]');
        helper = card.querySelector('[data-frozt-upgrade-price-line]');
        prices = card.querySelector('[data-frozt-upgrade-prices]');
      } else if (kind === 'secondary') {
        button = card.querySelector('[data-frozt-pack-standard-button]');
        title = card.querySelector('strong');
        subline = card.querySelector('p');
        helper = card.querySelector('[data-frozt-pack-standard-disclosure]');
        prices = card.querySelector('[data-frozt-pack-standard-price]');
      } else {
        button = card.querySelector('[data-frozt-stocked-upgrade-button]');
        title = card.querySelector('strong');
        subline = card.querySelector('[data-frozt-stocked-upgrade-copy]');
        helper = card.querySelector('[data-frozt-stocked-upgrade-helper]');
        prices = card.querySelector('[data-frozt-stocked-upgrade-price]');
      }
      text(title,titles[plan.target.index]);
      text(subline,contents(plan.target.index));
      if (kind === 'primary' || kind === 'secondary') {
        const chips=card.querySelectorAll('.frozt-cart-drawer__upgrade-badges > span, .frozt-pack-chips > span');
        const labels = plan.target.index === 4 ? ['Final step','Full routine','Keep your packs'] : plan.target.index >= 2 ? [titles[plan.target.index],'2 of 3 steps','Brush not included'] : plan.target.index === 1 ? refillChips : primaryChips;
        labels.forEach((label,index) => { text(chips[index],label); show(chips[index],Boolean(label)); });
        text(card.querySelector('.frozt-pack-badge'),plan.target.index >= 2 ? titles[plan.target.index].toUpperCase() : plan.target.index === 1 ? refillBadge : primaryBadge);
      }
      text(helper,looseCompleteDisplay(cart,plan) ? 'Same routine · bundle price + free shipping' : plan.key === 'mixed' ? plan.helper : plan.target.index === 0 ? (physical(cart).filter(Boolean).length === 2 ? 'Add the final step + unlock free shipping' : 'Complete your routine + free shipping') : plan.target.index === 1 ? 'Stay stocked longer with fewer reorders' : plan.helper);
      if (helper) helper.title = plan.helper;
      show(helper,plan.target.index !== 4);
      if (helper) { helper.style.color = '#0E335F'; helper.style.fontWeight = '650'; }
      priceNodes(prices,plan,cart);
      const saving = Math.max(0,-plan.delta);
      let label = plan.target.index === 4 ? 'ADD THE FINAL STEP' : plan.target.index === 1 ? 'UPGRADE WITH REFILLS' : 'COMPLETE MY SYSTEM';
      if (saving || plan.delta === 0) label = 'SWITCH TO ' + ['COMPLETE','REFILLS','DAILY ROUTINE PACK','ICE BAR PACK'][plan.target.index] + (saving ? ' · SAVE ' + money(saving,cart) : '');
      if (plan.key === 'mixed') label = 'SWITCH BOTH PACKS TO REFILLS';
      if (button) {
        show(button,true);
        if (plan.target.index === 4) {
          delete button.dataset.froztExplicitOffer;
          button.dataset.froztExplicitComponent = '0';
          button.dataset.froztComponentAction = 'add';
        } else {
          button.dataset.froztExplicitOffer = plan.key;
          delete button.dataset.froztExplicitComponent;
          delete button.dataset.froztComponentAction;
        }
        delete button.dataset.upgradeMode;
        delete button.dataset.targetVariantId;
        text(button.querySelector('[data-frozt-upgrade-button-text]') || button,label);
        button.disabled = Boolean(pending || c.busy());
        button.removeAttribute('aria-busy');
      }
      if (plan.target.image) {
        const media = card.querySelector('.frozt-cart-drawer__upgrade-visuals, .frozt-pack-media, .frozt-stocked-media');
        if (media?.tagName === 'IMG') media.src = plan.target.image;
        else if (media) { const img = document.createElement('img'); img.src = plan.target.image; img.alt = titles[plan.target.index]; media.replaceChildren(img); }
      }
    }
    function render(cart) {
      if (!cart) return;
      const totals = physical(cart), ready = totals.filter(Boolean).length;
      const offers = catalog(), hasComplete = quantity(cart,offers[0].id)>0, hasRefills = quantity(cart,offers[1].id)>0;
      const mixedPacks = quantity(cart,offers[2].id)>0 && quantity(cart,offers[3].id)>0;
      const label = ready === 3 ? (hasRefills && !hasComplete ? 'Complete system + refills ready' : hasComplete ? 'Full system unlocked ✓' : 'Your 3-step routine is complete ✓') : ready === 2 ? 'One step from the full system' : 'Complete the system';
      const topValue = find('[data-frozt-top-progress-count]');
      text(topValue,ready + ' of 3 steps ready');
      show(top,ready > 0 && c.uiEnabled !== false);
      top?.classList.toggle('is-unlocked',ready === 3);
      root.querySelectorAll('[data-frozt-progress-track]').forEach(node => node.setAttribute('aria-valuenow',String(ready)));
      root.querySelectorAll('[data-frozt-progress-fill]').forEach(node => { node.style.width = ready/3*100 + '%'; });
      root.querySelector('.frozt-cart-drawer__panel')?.classList.toggle('has-complete-system',ready === 3);
      const interactive = ready === 1 && c.uiEnabled !== false;
      show(ladder,interactive);
      ladder?.classList.toggle('is-two-step',ready === 2);
      text(find('[data-frozt-progress-heading]'),label);
      text(find('[data-frozt-progress-title]'),ready + ' of 3 steps ready');
      root.querySelectorAll('[data-frozt-routine-step]').forEach((step,index) => {
        const active = totals[index] > 0, offer = offers[index+4];
        const actionable = interactive && (active ? rows(cart,offer.id).length > 0 : offerReady(cart,offer,1));
        step.classList.toggle('is-active',active);
        step.classList.toggle('is-clickable',actionable);
        const button = step.querySelector('[data-frozt-routine-add]');
        text(step.querySelector('[data-frozt-routine-meta]'),(index === 0 ? 'Deep cleanse' : index === 1 ? 'Removes sweat & oil' : 'Face + body cleanse') + '\n' + (active ? totals[index] + 'x included' : 'Missing'));
        if (button) {
          delete button.dataset.upgradeMode; delete button.dataset.targetVariantId; delete button.dataset.routineType; delete button.dataset.froztExplicitComponent; delete button.dataset.froztComponentAction;
          button.hidden = !actionable;
          button.disabled = !actionable || Boolean(pending || c.busy());
          if (actionable) {
            button.dataset.froztExplicitComponent = String(index);
            button.dataset.froztComponentAction = active ? 'remove' : 'add';
          }
          button.setAttribute('aria-label',(active ? 'Remove 1 ' : 'Add 1 ') + titles[index+4]);
        }
      });
      show(confirmation,ready === 3 && (hasComplete || hasRefills) && c.uiEnabled !== false);
      if (confirmation && funnel) {
        if (ready === 3) funnel.before(confirmation); else funnel.after(confirmation);
      }
      text(confirmation?.querySelector('.frozt-cart-drawer__complete-copy strong'),label);
      show(confirmation?.querySelector('.frozt-cart-drawer__complete-copy'),hasRefills);
      show(find('[data-frozt-bundle-applied]'),ready === 3 && (hasComplete || hasRefills));
      text(find('[data-frozt-bundle-applied] strong'),hasComplete ? 'Bundle price applied ✓' : appliedCopy);
      text(find('[data-frozt-bundle-applied-detail]'),hasRefills ? 'Complete System + Refills in your cart' : 'Complete FROZT System in your cart');
      show(find('[data-frozt-cart-value-row]'),(hasComplete || hasRefills) && c.uiEnabled !== false);
      show(find('[data-frozt-stocked-confirmation]'),hasRefills);
      show(find('[data-frozt-cart-addon]'),false);
      show(find('[data-frozt-pack-config-warning]'),false);
      const info = plans(cart);
      currentPlans = new Map(info.items.map(plan => [plan.key,plan]));
      if (c.uiEnabled === false || !ready) currentPlans.clear();
      const completePlan = currentPlans.get('complete');
      const refillPlan = currentPlans.get('mixed') || currentPlans.get('refills');
      const packPlan = currentPlans.get('pack');
      const exactPack = ready === 2 && packPlan && totals.every((n,axis) => n === recipes[packPlan.target.index][axis]);
      const preferRefills = ready === 3 && (totals.every((n,axis) => n === recipes[1][axis]) || (quantity(cart,offers[2].id) + quantity(cart,offers[3].id) > 0));
      const primaryPlan = mixedPacks ? refillPlan : !hasComplete && !hasRefills ? (exactPack ? packPlan : (preferRefills || !completePlan) ? refillPlan : completePlan) : null;
      const secondaryPlan = ready === 2 && !hasComplete && !hasRefills && exactPack ? completePlan : null;
      const stockedPlan = !mixedPacks && hasComplete && !hasRefills ? refillPlan : null;
      const nextPlan = completePlan || refillPlan;
      const fullSaving = Math.max(0,recipes[0].reduce((sum,n,axis) => sum + n * offers[axis+4].price,0) - offers[0].price);
      const cleanserPack = ready === 2 && quantity(cart,offers[2].id)>0;
      // Restore the checkpoint's state copy without claiming a bundle was applied to loose items.
      const progressLabel = hasComplete ? 'Full system unlocked ✓' : hasRefills ? 'Full system unlocked' : ready === 3 ? 'Your 3-step routine is complete ✓' : cleanserPack ? 'One step from the full system' : ready === 2 ? 'Add the final step' : totals[1] > 0 ? 'Complete the routine' : 'Complete the system';
      text(find('[data-frozt-top-progress-label]'),progressLabel);
      const support = hasRefills ? 'Full routine + refills included' : hasComplete ? '' : cleanserPack ? '2 of 3 steps ready' : ready === 3 ? '' : ready === 2 && quantity(cart,offers[3].id)>0 ? 'Keep your refills & complete the system' : ready === 2 && nextPlan ? (nextPlan.delta < 0 ? 'Pay ' + money(-nextPlan.delta,cart) + ' less than your current cart' : 'Complete for ' + money(nextPlan.delta,cart) + ' more') : fullSaving > 0 ? 'Save ' + money(fullSaving,cart) + ' + free shipping' : 'Free shipping with the full system';
      text(find('[data-frozt-top-progress-support]'),support);
      show(find('[data-frozt-top-progress-support]'),Boolean(support));
      paintCard(primary,primaryPlan,cart,'primary');
      paintCard(secondary,secondaryPlan,cart,'secondary');
      paintCard(stocked,stockedPlan,cart,'stocked');
      show(funnel,interactive || Boolean(primaryPlan || secondaryPlan));
      if (!selector) {
        selector = document.createElement('div'); selector.className = 'frozt-cart-drawer__upgrade-quantity';
        selector.setAttribute('role','group'); selector.setAttribute('aria-label','Upgrade quantity:');
        selector.setAttribute('data-frozt-explicit-selector','');
      }
      const host = stockedPlan ? stocked : primary;
      show(selector,info.capacity > 1 && Boolean(primaryPlan || secondaryPlan || stockedPlan));
      if (!selector.hidden && host) {
        host.before(selector); selector.replaceChildren();
        const labelNode = document.createElement('span'); labelNode.textContent = 'Upgrade quantity:'; selector.append(labelNode);
        for (let n=1;n<=info.capacity;n++) {
          const button=document.createElement('button'); button.type='button'; button.textContent=String(n);
          button.dataset.froztExplicitQuantity=String(n); button.setAttribute('aria-pressed',String(n === selection));
          button.disabled=Boolean(pending || c.busy()); selector.append(button);
        }
      }
      // Applied pricing describes only the actual Shopify lines, never a hypothetical offer.
      const paid = Number(cart.total_price) || 0;
      let reference = paid;
      for (const item of cart.items || []) {
        const index = offers.findIndex(offer => offer.id > 0 && offer.id === idOf(item));
        const actual = Number(item.final_line_price ?? item.line_price) || 0;
        const original = Number(item.original_line_price ?? item.line_price) || actual;
        let compare = original;
        if (index >= 0 && index < 4) compare = Math.max(compare,recipes[index].reduce((sum,n,axis) => sum + n * offers[axis+4].price,0) * item.quantity);
        reference += Math.max(0,compare-actual);
      }
      text(find('[data-frozt-cart-subtotal]'),money(paid,cart));
      const regular = find('[data-frozt-cart-regular]');
      show(regular,reference > paid); text(regular,reference > paid ? money(reference,cart) : '');
      let saving = find('[data-frozt-cart-total-save]');
      if (!saving && regular) { saving = document.createElement('small'); saving.dataset.froztCartTotalSave=''; regular.after(saving); }
      show(saving,reference > paid); text(saving,'Save ' + money(reference-paid,cart));
      root.querySelectorAll('[data-frozt-cart-action]').forEach(button => { button.disabled=Boolean(pending || c.busy()); });
    }
    function journal(value) {
      try { if (value) sessionStorage.setItem(journalKey,JSON.stringify(value)); else sessionStorage.removeItem(journalKey); } catch (_) {}
    }
    const addData = (item,n) => ({id:idOf(item),quantity:n,...(Object.keys(item.properties || {}).length ? {properties:item.properties} : {})});
    async function rollback(tx) {
      // Restore selected originals first; delete only this transaction's target addition.
      let cart = await read();
      for (const row of tx.sources) {
        const missing = row.before-count(cart,row.identity);
        if (missing > 0) { await post('cart/add.js',{items:[addData(row.item,missing)]}); cart = await read(); }
      }
      const added = count(cart,tx.target.identity)-tx.target.before;
      if (added > 0) {
        let remaining = added;
        const updates = {};
        for (const item of cart.items.filter(item => identity(item) === tx.target.identity)) {
          const take = Math.min(remaining,item.quantity);
          updates[item.key] = item.quantity-take; remaining -= take;
        }
        await post('cart/update.js',{updates}); cart = await read();
      }
      if (tx.sources.some(row => count(cart,row.identity) !== row.before) || count(cart,tx.target.identity) !== tx.target.before) throw new Error('Unable to confirm the restored cart. Your cart controls remain available.');
      journal(null);
      return cart;
    }
    async function recover() {
      let tx;
      try { tx = JSON.parse(sessionStorage.getItem(journalKey) || 'null'); } catch (_) { journal(null); }
      if (!tx) return;
      const cart = await read();
      const valid=Array.isArray(tx.sources)&&tx.sources.length&&tx.sources.every(row => row&&row.item&&row.identity===identity(row.item)&&Number.isInteger(row.before)&&Number.isInteger(row.take)&&row.take>0&&row.take<=row.before)&&tx.target?.item&&tx.target.identity===identity(tx.target.item)&&Number.isInteger(tx.target.before)&&tx.target.before>=0&&Number.isInteger(tx.n)&&tx.n>0;
      if (!valid || !tx.time || Date.now()-tx.time > 120000 || !cart.token || cart.token !== tx.token) { journal(null); return; }
      // A committed CTA is retained as that exact SKU; only incomplete actions roll back.
      const done = tx.sources.every(row => count(cart,row.identity) === row.before-row.take) && count(cart,tx.target.identity) === tx.target.before+tx.n;
      if (done) { journal(null); return; }
      const originalsIntact=tx.sources.every(row => count(cart,row.identity) === row.before);
      const targetAdded=count(cart,tx.target.identity)-tx.target.before;
      const safe = tx.sources.every(row => count(cart,row.identity) >= row.before-row.take && count(cart,row.identity) <= row.before) && targetAdded>=0 && targetAdded<=tx.n && (originalsIntact || targetAdded===tx.n);
      if (!safe) { journal(null); return; }
      // A fresh, validated transaction may retry after a temporary outage; it never owns a UI lock.
      try { await rollback(tx); } catch (_) {}
    }
    async function convert(cart,plan) {
      const targetItem = {variant_id:plan.target.id,properties:plan.properties};
      const sourceSnapshots = new Map();
      for (const row of plan.sources) {
        const key=identity(row.item), snapshot=sourceSnapshots.get(key);
        if (snapshot) snapshot.take+=row.take;
        else sourceSnapshots.set(key,{item:clone(row.item),identity:key,before:count(cart,key),take:row.take});
      }
      const tx = {time:Date.now(),token:cart.token,n:plan.n,target:{item:targetItem,identity:identity(targetItem),before:count(cart,identity(targetItem))},
        sources:[...sourceSnapshots.values()]};
      journal(tx);
      try {
        await post('cart/add.js',{items:[{id:plan.target.id,quantity:plan.n,...(Object.keys(plan.properties).length ? {properties:plan.properties} : {})}]});
        let added = await read();
        if (count(added,tx.target.identity) !== tx.target.before+plan.n) throw new Error('The offer could not be added completely.');
        const updates = {};
        for (const row of tx.sources) {
          let remaining=row.take;
          const candidates=added.items.filter(item => identity(item) === row.identity);
          for (const source of candidates) {
            const used=Math.min(remaining,source.quantity);
            if (used) updates[source.key]=source.quantity-used;
            remaining-=used;
          }
          if (remaining) throw new Error('Your cart changed. Please choose the offer again.');
        }
        await post('cart/update.js',{updates});
        const result = await read();
        const expected = physical(cart);
        plan.sources.forEach(row => {
          const index=catalog().findIndex(offer => offer.id === idOf(row.item));
          recipes[index].forEach((n,axis) => expected[axis]-=n*row.take);
        });
        recipes[plan.target.index].forEach((n,axis) => expected[axis]+=n*plan.n);
        const targetOK = count(result,tx.target.identity) === tx.target.before+plan.n;
        const sourcesOK = tx.sources.every(row => count(result,row.identity) === row.before-row.take);
        const untouched = cart.items.filter(item => !tx.sources.some(row => row.identity === identity(item)) && identity(item) !== tx.target.identity);
        if (!targetOK || !sourcesOK || stable(physical(result)) !== stable(expected) || untouched.some(item => count(result,identity(item)) !== count(cart,identity(item)))) throw new Error('The offer was not applied completely.');
        journal(null); return result;
      } catch (error) {
        let restored = false;
        for (let attempt=0;attempt<2&&!restored;attempt++) {
          try { await rollback(tx); restored=true; } catch (_) {}
        }
        throw new Error(restored ? 'The offer could not be completed. Your original products were restored.' : 'The offer could not be completed. Your cart is editable; reopen to retry recovery.');
      }
    }
    async function run(action) {
      if (pending || c.busy()) return;
      c.lock(true); c.status('Updating your cart…');
      let failure = null;
      pending = Promise.resolve().then(async () => {
        if (reading) await reading.catch(() => {});
        const cart = await read();
        const result = await action(cart);
        c.render(result?.items ? result : await read());
      }).catch(async error => {
        failure = error;
        try { c.render(await read()); } catch (_) {}
      }).finally(() => {
        pending=null; c.lock(false);
        c.status(failure ? failure.message : '',Boolean(failure));
      });
      render(c.cart());
      return pending;
    }
    async function refresh() {
      if (pending) await pending;
      if (reading) return reading;
      reading = (async () => {
        await recover();
        const cart = await read(); c.render(cart); return cart;
      })().finally(() => { reading=null; });
      return reading;
    }
    root.addEventListener('click',event => {
      const button = event.target.closest('[data-frozt-cart-action],[data-frozt-explicit-offer],[data-frozt-explicit-component],[data-frozt-explicit-quantity]');
      if (!button || !root.contains(button)) return;
      event.preventDefault(); event.stopImmediatePropagation();
      if (pending || c.busy() || button.disabled) return;
      if (button.dataset.froztExplicitQuantity) {
        selection = Number(button.dataset.froztExplicitQuantity); render(c.cart()); return;
      }
      if (button.dataset.froztCartAction) {
        const visible = c.cart()?.items[Number(button.dataset.line)-1];
        if (!visible) return;
        const occurrence=c.cart().items.filter(item => identity(item) === identity(visible)).findIndex(item => item.key === visible.key);
        const remove = button.dataset.froztCartAction === 'remove';
        const delta = Number(button.dataset.quantity)-visible.quantity;
        void run(async cart => {
          const matches=cart.items.filter(item => identity(item) === identity(visible));
          const item=cart.items.find(item => item.key === visible.key) || matches[occurrence];
          if (!item) return cart;
          return post('cart/change.js',{id:item.key,quantity:remove ? 0 : Math.max(0,item.quantity+delta)});
        });
      } else if (button.dataset.froztExplicitComponent != null) {
        const index=Number(button.dataset.froztExplicitComponent);
        const remove=button.dataset.froztComponentAction === 'remove';
        void run(async cart => {
          const offer=catalog()[index+4];
          if (remove) {
            const item=rows(cart,offer.id)[0];
            return item ? post('cart/change.js',{id:item.key,quantity:Math.max(0,item.quantity-1)}) : cart;
          }
          if (physical(cart)[index]>0 || !offerReady(cart,offer,1)) return cart;
          await post('cart/add.js',{items:[{id:offer.id,quantity:1}]}); return read();
        });
      } else {
        const key=button.dataset.froztExplicitOffer;
        void run(async cart => {
          const plan=plans(cart).items.find(plan => plan.key === key);
          if (!plan) throw new Error('This offer is no longer available. Your cart is unchanged.');
          return convert(cart,plan);
        });
      }
    },{capture:true,signal:c.signal});
    root.froztPartialUpgrades = {render,refresh,physical};
    if (c.cart()) render(c.cart());
  }
  window.FroztPartialUpgrades = {attach};
  const init = () => document.querySelectorAll('[id^="frozt-exact-header-"]').forEach(attach);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();
